import React, { useState } from "react";
import Textfield from "../Textfield";
import { Colors } from "../../config/Constants";
import Modal from "../Modal";
import Button from "../Button";
import dayjs from "dayjs";

const SendLinkModal = ({ setSendLinkModal, membershipDetails, onSendLink }) => {
  const [amount, setAmount] = useState(0);
  return (
    <Modal
      variant={"none"}
      setOpenOrClose={() => setSendLinkModal(false)}
      width={"350px"}
    >
      <div
        style={{
          padding: "1rem",
          display: "flex",
          gap: "1rem",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div />
          <div>Renew Membership</div>
          <img
            onClick={() => setSendLinkModal(false)}
            style={{ width: "1rem", height: "1rem" }}
            src={require("../../assets/images/close.png")}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div style={{ fontSize: "14px", textAlign: "center" }}>
            Please enter the membership amount to generate and send the payment
            link.
          </div>
          <div>
            <div style={{ fontSize: "14px", fontWeight: 300 }}>Name</div>
            <div
              style={{
                fontSize: "12px",
                color: Colors.cloudyGrey,
                fontWeight: 300,
              }}
            >
              {membershipDetails?.name + " " + membershipDetails?.lastname ||
                "-"}
            </div>
          </div>
          <div>
            <div style={{ fontSize: "14px", fontWeight: 300 }}>Email</div>
            <div
              style={{
                fontSize: "12px",
                color: Colors.cloudyGrey,
                fontWeight: 300,
              }}
            >
              {membershipDetails?.email || "-"}
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <div style={{ fontSize: "14px", fontWeight: 300 }}>Car</div>
              <div
                style={{
                  fontSize: "12px",
                  color: Colors.cloudyGrey,
                  fontWeight: 300,
                }}
              >
                {membershipDetails?.carBrand + membershipDetails?.carModel ||
                  ""}
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "14px", fontWeight: 300 }}>
                Plate Number
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: Colors.cloudyGrey,
                  fontWeight: 300,
                }}
              >
                {membershipDetails?.carPlateNo}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <div style={{ fontSize: "14px", fontWeight: 300 }}>
                Registered On
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: Colors.cloudyGrey,
                  fontWeight: 300,
                }}
              >
                {dayjs(membershipDetails?.startDate).format("DD MMM YYYY")}
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "14px", fontWeight: 300 }}>
                Expiry Date
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: Colors.cloudyGrey,
                  fontWeight: 300,
                }}
              >
                {dayjs(membershipDetails?.endDate).format("DD MMM YYYY")}
              </div>
            </div>
          </div>
          <Textfield
            onChange={(e) => setAmount(e.target.value)}
            label="Amount"
            required
            placeholder={""}
            variant={""}
            value={amount}
            type="number"
          />
          <Button
            disabled={Number(amount) < 0}
            isRounded
            variant="filled"
            fontColor={Colors.white}
            color={Colors.red}
            label="Send Payment Link"
            onClick={() => onSendLink(Number(amount))}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SendLinkModal;
